export default __webpack_public_path__ + "static/media/black-3.d2931b2b.png";